import store from "@/store";
import { useCount } from "@/utils/count";

const load = async () => {
    await useCount().countFinance();
    await useCount().countBill();
};

export default [
    {
        path: "/finance",
        name: "finance__root__",
        redirect: {
            name: "finance-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "finance",
            title: "",
        },
        beforeEnter: async (to, from, next) => {
            try {
                await load();
            } catch (err) {
                console.error(err);
            } finally {
                next();
            }
        },
        children: [
            {
                path: "index",
                name: "finance-index",
                component: () => import("@/views/fms/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/finance/bill",
        name: "finance-bill",
        meta: {
            title: "账单管理",
            icon: "finance-bill",
            parent: "finance",
            permission: "manage_bill",
        },
        beforeEnter: async (to, from, next) => {
            await useCount().countBill();
            store.dispatch("goods/loadCategories");
            next();
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/finance/bill/order-collection",
        children: [
            {
                path: "order-collection",
                name: "finance-bill-order-collection",
                component: () => import("@/views/fms/bill/order-collection.vue"),
                meta: {
                    title: "签单收款",
                    icon: "finance-order-collection",
                    affix: false,
                    keepAlive: true,
                },
            },
            {
                path: "collection-detail/:id(\\d+)?",
                name: "finance-bill-collection-detail",
                hidden: true,
                component: () => import("@/views/fms/bill/collection-detail.vue"),
                meta: {
                    title: "收款详情",
                    affix: false,
                    activeMenu: "/finance/bill/order-collection",
                },
            },
            {
                path: "quick-receipt",
                name: "finance-bill-quick-receipt",
                component: () => import("@/views/fms/bill/quick-payment.vue"),
                meta: {
                    title: "快捷收款",
                    icon: "finance-quick-receipt",
                    affix: false,
                },
            },
            {
                path: "quick-receipt/detail/:id(\\d+)?",
                name: "finance-bill-quick-receipt-detail",
                hidden: true,
                component: () => import("@/views/fms/bill/quick-payment-detail.vue"),
                meta: {
                    title: "收款详情",
                    affix: false,
                    activeMenu: "/finance/bill/quick-receipt",
                },
            },
            {
                path: "pending-orders",
                name: "finance-bill-pending-orders",
                component: () => import("@/views/fms/mall/pending_order.vue"),
                meta: {
                    title: "商城收款",
                    icon: "finance-mall-orders",
                    affix: false,
                },
            },
            {
                path: "pending-orders/detail/:id(\\d+)?",
                name: "finance-bill-pending-orders-detail",
                hidden: true,
                component: () => import("@/views/fms/mall/order_detail.vue"),
                meta: {
                    title: "订单详情",
                    affix: false,
                    activeMenu: "/finance/bill/pending-orders",
                },
            },
            {
                path: "oem-detail/:id",
                name: "finance-bill-oem-detail",
                hidden: true,
                component: () => import("@/views/fms/bill/oem-detail.vue"),
                meta: {
                    title: "OEM收款详情",
                    affix: false,
                    activeMenu: "/finance/bill/oem",
                },
            },
            {
                path: "oem",
                name: "finance-bill-oem",
                component: () => import("@/views/fms/bill/oem.vue"),
                meta: {
                    title: "OEM收款",
                    icon: "finance-bill-oem",
                    affix: false,
                },
            },
            {
                path: "pay/eurofins/:id(\\d+)?",
                name: "finance-bill-pay-eurofins",
                hidden: true,
                component: () => import("@/views/eurofins/sensing/order-detail.vue"),
                meta: {
                    title: "订单详情",
                    key: "bill",
                    activeMenu: "/finance/bill/pay",
                },
            },
            {
                path: "purchase/pay",
                name: "finance-bill-purchase-pay",
                component: () => import("@/views/pus/order.vue"),
                meta: {
                    title: "采购付款",
                    icon: "finance-purchase-pay",
                    affix: false,
                },
            },
            {
                path: "purchase/pay/detail/:id(\\d+)?",
                name: "finance-bill-purchase-pay-detail",
                component: () => import("@/views/pus/order_detail.vue"),
                hidden: true,
                meta: {
                    title: "订单详情",
                    affix: false,
                    activeMenu: "/finance/bill/purchase-pay",
                },
            },
            {
                path: "purchase/pay/edit/:id(\\d+)?",
                name: "finance-bill-purchase-pay-edit",
                hidden: true,
                component: () => import("@/views/pus/order_edit.vue"),
                meta: {
                    title: "订单编辑",
                    affix: false,
                    activeMenu: "/finance/bill/purchase-pay",
                },
            },
            {
                path: "maintenance",
                name: "finance-bill-maintenance",
                component: () => import("@/views/fms/bill/maintenance.vue"),
                meta: {
                    title: "维保收款",
                    icon: "finance-bill-maintenance",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/finance/receipt",
        name: "finance-receipt",
        meta: {
            title: "收款记录",
            icon: "finance-receipt-log",
            parent: "finance",
        },
        component: () => import("@/layouts/default.vue"),
        beforeEnter: async (to, from, next) => {
            await useCount().countBill();
            next();
        },
        children: [
            {
                path: "statement",
                name: "finance-bill-statement",
                component: () => import("@/views/fms/bill/statement.vue"),
                meta: {
                    title: "线下收款",
                    icon: "finance-bill-statement",
                    affix: false,
                },
            },
            {
                path: "statement-detail/:id",
                name: "finance-bill-statement-detail",
                component: () => import("@/views/fms/bill/statement-detail.vue"),
                hidden: true,
                meta: {
                    title: "收款详情",
                    affix: false,
                    activeMenu: "/finance/bill/statement",
                },
            },
            {
                path: "pay",
                name: "finance-bill-pay",
                component: () => import("@/views/fms/bill/pay.vue"),
                meta: {
                    title: "线上支付",
                    icon: "finance-bill-pay",
                    affix: false,
                },
            },
            {
                path: "pay-detail/:id",
                name: "finance-pay-detail",
                component: () => import("@/views/fms/bill/pay-detail.vue"),
                hidden: true,
                meta: {
                    title: "支付详情",
                    affix: false,
                    activeMenu: "/finance/bill/pay",
                },
            },
        ],
    },
    // {
    //     path: "/finance/promotion",
    //     name: "finance-promotion",
    //     meta: {
    //         title: "推广返现",
    //         icon: "finance-bill",
    //         parent: "finance",
    //         permission: "manage_bill",
    //     },
    //     component: () => import("@/layouts/default.vue"),
    //     redirect: "/finance/promotion/rebate",
    //     children: [
    //         {
    //             path: "rebate",
    //             name: "finance-promotion-rebate",
    //             component: () => import("@/views/fms/finance/promotion-rebate.vue"),
    //             meta: {
    //                 title: "返现管理",
    //                 icon: "finance-bill",
    //                 affix: false,
    //             },
    //         },
    //         {
    //             path: "rebate/:id(\\d+)",
    //             name: "finance-promotion-rebate-detail",
    //             hidden: true,
    //             component: () => import("@/views/fms/finance/promotion-rebate-detail.vue"),
    //             meta: {
    //                 title: "佣金详情",
    //                 affix: false,
    //                 activeMenu: "/finance/promotion/rebate",
    //             },
    //         },
    //     ],
    // },
    {
        path: "/finance/promotion",
        name: "finance-promotion",
        meta: {
            title: "推广返现",
            icon: "finance-bill",
            parent: "finance",
            permission: "manage_bill",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/finance/promotion/rebate",
        children: [
            {
                path: "rebate",
                name: "finance-promotion-rebate",
                component: () => import("@/views/fms/finance/promotion-rebate.vue"),
                meta: {
                    title: "返现管理",
                    icon: "finance-bill",
                    affix: false,
                },
            },
            {
                path: "rebate/:id(\\d+)",
                name: "finance-promotion-rebate-detail",
                hidden: true,
                component: () => import("@/views/fms/finance/promotion-rebate-detail.vue"),
                meta: {
                    title: "佣金详情",
                    affix: false,
                    activeMenu: "/finance/promotion/rebate",
                },
            },
        ],
    },
    {
        path: "/finance/invoice",
        name: "finance-invoice",
        meta: {
            title: "发票管理",
            icon: "finance-invoice",
            parent: "finance",
            permission: "manage_invoice",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/finance/invoice/invoice_pending",
        beforeEnter: async (to, from, next) => {
            await useCount().countFinance();
            next();
        },
        children: [
            {
                path: "pending",
                name: "finance-invoice-pending",
                component: () => import("@/views/fms/invoice/pending.vue"),
                meta: {
                    title: "待开发票",
                    icon: "finance-invoice-pending",
                    affix: false,
                },
            },
            {
                path: "complete",
                name: "finance-invoice-complete",
                component: () => import("@/views/fms/invoice/complete.vue"),
                meta: {
                    title: "已开发票",
                    icon: "finance-invoice-complete",
                    affix: false,
                },
            },
            {
                path: "reject",
                name: "finance-invoice-reject",
                component: () => import("@/views/fms/invoice/reject.vue"),
                meta: {
                    title: "拒开记录",
                    icon: "finance-invoice-reject",
                    affix: false,
                },
            },
            {
                path: "detail/:status/:id",
                name: "finance-invoice-detail",
                component: () => import("@/views/fms/invoice/invoice-detail.vue"),
                hidden: true,
                meta: {
                    title: "发票详情",
                    affix: false,
                    activeMenu: "/finance/invoice/pending",
                },
            },
        ],
    },
    {
        path: "/finance/exception",
        name: "finance-exception",
        meta: {
            title: "系统管理",
            icon: "all-system",
            parent: "finance",
            permission: "manage_bill",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/finance/exception/exception",
        children: [
            {
                path: "exception",
                name: "finance-bill-exception",
                component: () => import("@/views/fms/bill/exception.vue"),
                meta: {
                    title: "异常处理",
                    icon: "finance-bill-exception",
                    affix: false,
                },
            },
            {
                path: "exception-order",
                name: "finance-bill-exception-order",
                component: () => import("@/views/fms/bill/exception-order.vue"),
                meta: {
                    title: "异常订单",
                    icon: "finance-exception-order",
                    affix: false,
                },
            },
        ],
    },
];
